import styled from "styled-components";

const Radio = styled.input.attrs((props) => ({
  type: "radio",
}))`
  cursor: pointer;
  appearance: none;
  position: relative;
  margin: 0;
  width: ${({ theme }) => theme.sizeRadio};
  height: ${({ theme }) => theme.sizeRadio};
  border: ${({ theme }) => {
    return `${theme.borderWidthRadio} solid ${theme.colors.inactiveRadioButton}`;
  }};
  border-radius: 50%;
  display: inline-grid;
  place-content: center;
  outline: none;

  &:focus::before {
    content: "";
    position: absolute;
    left: -5px;
    right: -5px;
    top: -5px;
    bottom: -5px;
    border: ${(props) => `2px solid ${props.theme.colors.activeInputOutline}`};
    border-radius: 50%;
  }

  &:checked {
    background-color: ${({ theme }) => {
      return theme.colors.baseWhite;
    }};
  }

  &::after {
    box-sizing: border-box;
  }

  &:checked::after {
    content: "";
    display: block;
    border-radius: 50%;
    width: ${({ theme }) => theme.sizeRadioCheckMark};
    height: ${({ theme }) => theme.sizeRadioCheckMark};
    background-color: ${({ theme }) => {
      return theme.colors.primary2;
    }};
  }

  &:disabled::after {
    background-color: ${(props) => props.theme.colors.base5};
  }
`;

export default Radio;
